module.exports = __webpack_public_path__ + "img/signatureEle.421dab38.svg";